import { render, staticRenderFns } from "./Nudim.vue?vue&type=template&id=27d9ab2c&"
import script from "./Nudim.vue?vue&type=script&lang=js&"
export * from "./Nudim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports